import styled from "styled-components";

export const Main = styled.article`
padding: 20px;
max-width: 800px;
margin: 20px auto;
`;

export const Article = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 15px;
`;

export const SubTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 15px;
`;

export const Description = styled.p`
  font-size: 16px;
  margin-bottom: 15px;
  color: #333;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
